import { Injectable, inject } from '@angular/core';
import { State, Action, StateContext, Actions, ofActionDispatched } from '@ngxs/store';
import { ErrorToast, SuccessToast, ToastMessage, ToastService } from '../layouts/toast.service';
import { ShowToast } from './common.actions';

export class CommonStateModel {
  public items: string[] = [];
}

const defaults = {
  items: []
};

@State<CommonStateModel>({
  name: 'common',
  defaults
})
@Injectable()
export class CommonState {

  actions$ = inject(Actions);

  configureContractorPayroll$ = this.actions$
    .pipe(ofActionDispatched(ShowToast))
    .subscribe((action: ShowToast) => {
      let toastObject: ToastMessage | undefined

      if (action.type === 'success') {
        toastObject = new SuccessToast(action.title, action.message);
      } else if (action.type ==='error') {
        toastObject = new ErrorToast(action.title, action.message);
      }

      if (toastObject) {
        this.toast.show(toastObject, { delay: 3000, classname: 'success', html: true });
      }

      // this.modal.open(PayrollSetupComponent, { size: 'md' });
    })

  constructor(
    // private actions$: Actions,
    private toast: ToastService,
  ) {

  }


  // @Action(ShowToast)
  // add({ getState, setState }: StateContext<CommonStateModel>, { payload }: ShowToast) {
  //   const state = getState();
  //   setState({ items: [...state.items, payload] });
  // }
}
